module.exports = __webpack_public_path__ + "img/logo.f270a1d3.png";